import Vue from 'vue';
import VueRouter from 'vue-router';

//解决重复路由
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/download/index.vue'),
  },
  {
    path: '/explain',
    name: 'explain',
    component: () => import('../views/guild/explain.vue'),
  },

  {
    path: '/certification',
    name: 'certification',
    component: () => import('../views/guild/certification.vue'),
  },
  {
    path: '/mNotice',
    name: 'mNotice',
    component: () => import('../views/guild/mNotice.vue'),
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: () => import('../views/reception/instructions.vue'),
  },
  {
    path: '/callingRules',
    name: 'callingRules',
    component: () => import('../views/callingRules/index.vue'),
  },

  {
    path: '/agencyReseller',
    name: 'agencyReseller',
    component: () => import('../views/agencyReseller/index.vue'),
  },
  {
    path: '/resellerSummerEvent',
    name: 'resellerSummerEvent',
    component: () => import('../views/resellerSummerEvent/index.vue'),
  },
  {
    path: '/platformAnnouncementCn',
    name: 'platformAnnouncementCn',
    component: () => import('../views/platformAnnouncementCn/index.vue'),
  },
  {
    path: '/platformAnnouncementTw',
    name: 'platformAnnouncementTw',
    component: () => import('../views/platformAnnouncementTw/index.vue'),
  },
  // {
  //   path: '/downloadX',
  //   name: 'downloadX',
  //   component: () => import('../views/downloadX/index.vue'),
  // },
  {
    path: '/downloadApp',
    name: 'downloadApp',
    component: () => import('../views/downloadApp/index.vue'),
  },
  {
    path: '/downloadxia',
    name: 'downloadxia',
    component: () => import('../views/downloadApp/downloadxia.vue'),
  },
  {
    path: '/InvitationCode',
    name: 'InvitationCode',
    component: () => import('../views/InvitationCode/index.vue'),
  },

  {
    path: '/treasureChest',
    name: 'treasureChest',
    component: () => import('../views/treasureChest/index.vue?v=1.0.0'),
  },

  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/index.vue'),
  },
  {
    path: '/newIndex',
    name: 'newIndex',
    component: () => import('../views/downloadApp/newIndex.vue'),
  },
  {
    path: '/changePic',
    name: 'changePic',
    component: () => import('../views/changePic/index.vue'),
  },
  {
    path: '/picDetails',
    name: 'picDetails',
    component: () => import('../views/changePic/picDetails.vue'),
  },
  {
    path: '/picWithdrawal',
    name: 'picWithdrawal',
    component: () => import('../views/changePic/picWithdrawal.vue'),
  },
  {
    path: '/withdrawalInstructions',
    name: 'withdrawalInstructions',
    component: () => import('../views/withdrawalInstructions/index.vue'),
  },

  //靓号规则
  {
    path: '/prettyNumber',
    name: 'prettyNumber',
    component: () => import('../views/withdrawalInstructions/prettyNumber.vue'),
  },

  //weekly cp
  {
    path: '/weeklyCp',
    name: 'weeklyCp',
    component: () => import('../views/moveAbout/weeklyCp.vue'),
  },
  //weekly cp
  {
    path: '/weeklyCpTie',
    name: 'weeklyCpTie',
    component: () => import('../views/moveAbout/weeklyCpTie.vue'),
  },

  {
    path: '/roomParty',
    name: 'roomParty',
    component: () => import('../views/moveAbout/roomParty.vue'),
  },

  {
    path: '/roomPartyTie',
    name: 'roomPartyTie',
    component: () => import('../views/moveAbout/roomPartyTie.vue'),
  },
  //banner
  {
    path: '/pocket',
    name: 'pocket',
    component: () => import('../views/pocket/index.vue'),
  },

  {
    path: '/bannerA',
    name: 'bannerA',
    component: () => import('../views/pocket/bannerA.vue'),
  },
  {
    path: '/bannerB',
    name: 'bannerB',
    component: () => import('../views/pocket/bannerB.vue'),
  },
  {
    path: '/bannerC',
    name: 'bannerC',
    component: () => import('../views/pocket/bannerC.vue'),
  },
  {
    path: '/bannerD',
    name: 'bannerD',
    component: () => import('../views/pocket/bannerD.vue'),
  },
  {
    path: '/previleges',
    name: 'previleges',
    component: () => import('../views/pocket/previleges.vue'),
  },
  
  {
    path: '/officialMember',
    name: 'officialMember',
    component: () => import('../views/pocket/officialMember.vue'),
  },
  {
    path: '/TopUpRewards',
    name: 'TopUpRewards',
    component: () => import('../views/pocket/TopUpRewards.vue'),
  },
  {
    path: '/stopTaking',
    name: 'stopTaking',
    component: () => import('../views/pocket/stopTaking.vue'),
  },
  //活动奖励说明
  {
    path: '/eventRewards',
    name: 'eventRewards',
    component: () => import('../views/eventRewards/index.vue'),
  },
  {
    path: '/fiyat',
    name: 'fiyat',
    component: () => import('../views/pocket/fiyat.vue'),
  },


  //提现登录
  {
    path: '/withdrawalLogin',
    name: 'withdrawalLogin',
   component: () => import(
      /* webpackChunkName: "withdrawalLogin" */
      '../views/withdrawalLogin/index.vue'
    ),
    meta: { title: 'withdrawalLogin' }
  },

    //提现渠道
    {
      path: '/withdrawal',
      name: 'withdrawal',
   component: () => import(
      /* webpackChunkName: "withdrawal" */
      '../views/withdrawalLogin/withdrawal.vue'
    ),
    meta: { title: 'withdrawal' }
    },
    //提现详情
    {
      path: '/withdrawalDetails',
      name: 'withdrawalDetails',
   component: () => import(
      /* webpackChunkName: "withdrawalDetails" */
      '../views/withdrawalLogin/withdrawalDetails.vue'
    ),
    meta: { title: 'withdrawalDetails' }
    },
  {
    path: '/pixDetails',
    name: 'pixDetails',
    component: () => import('../views/withdrawalLogin/pixDetails.vue'),
  },
      // 传奇活动
      {
        path: '/legend',
        name: 'legend',
        component: () => import('../views/legend/index.vue'),
      },
      // 葡语区banner链接
      {
        path: '/portugueseBanner',
        name: 'portuguesebanner',
        component: () => import('../views/portugueseBanner/index.vue'),
      },
      // 注销账号说明
      {
        path: '/cancelAccount',
        name: 'cancelAccount',
        component: () => import('../views/cancelAccount/index.vue'),
      },
      // 斋月
      {
        path: '/ramadan',
        name: 'ramadan',
        component: () => import('../views/ramadan/index.vue'),
      },
      // 特权中心
      {
        path: '/centre',
        name: 'centre',
        component: () => import('../views/centre/index.vue'),
      },
      // 开斋节
      {
        path: '/alFitr',
        name: 'alFitr',
        component: () => import('../views/alFitr/index.vue'),
      },
      // 传奇4
      {
        path: '/legendaryApril',
        name: 'alFitr',
        component: () => import('../views/legendaryApril/index.vue'),
      },
      // 总榜更新礼物
      {
        path: '/overallRankGift',
        name: 'overallRankGift',
        component: () => import('../views/overallRankGift/index.vue'),
      },
      // diamonDrop说明
      {
        path: '/diamondDrop',
        name: 'diamondDrop',
        component: () => import('../views/diamondDrop/index.vue'),
      },
      // 表白墙说明
      {
        path: '/express',
        name: 'express',
        component: () => import('../views/express/index.vue'),
      },
      // adjust落地页视频
      {
        path: '/adjustPageThree',
        name: 'adjustPageThree',
        component: () => import('../views/adjustPageThree/index.vue'),
      },
      // adjust落地页视频
      {
        path: '/adjustPageOne',
        name: 'adjustPageOne',
        component: () => import('../views/adjustPageOne/index.vue'),
      },
      // adjust落地页视频
      {
        path: '/adjustPageTwo',
        name: 'adjustPageTwo',
        component: () => import('../views/adjustPageTwo/index.vue'),
      },
      // adjust落地页视频
      {
        path: '/adjustPageFour',
        name: 'adjustPageFour',
        component: () => import('../views/adjustPageFour/index.vue'),
      },
      // 万圣节页面
      {
        path: '/halloween',
        name: 'halloween',
        component: () => import('../views/halloween/index.vue'),
      },
      // 摩洛哥礼炮
      {
        path: '/moroccoGun',
        name: 'moroccoGun',
        component: () => import('../views/moroccoGun/index.vue'),
      },
      // mbti说明
      {
        path: '/mbtiDescribe',
        name: 'mbtiDescribe',
        component: () => import('../views/mbtiDescribe/index.vue'),
      },
      // reseller-list
      {
        path: '/resellerList',
        name: 'resellerList',
        component: () => import('../views/resellerList/index.vue?v=1.0.1'),
      },
      // 关系礼物说明
      {
        path: '/link_gift_des',
        name: 'express',
        component: () => import('../views/link_gift_des/index.vue?v=1.0.1'),
      },
      // 关系礼物说明全屏
      {
        path: '/link_gift_des_big',
        name: 'express',
        component: () => import('../views/link_gift_des/big_index.vue'),
      },
      // layla儿童协议
      {
        path: '/kid_deal_layla',
        name: 'kid_deal_layla',
        component: () => import('../views/kid_deal_layla/index.vue'),
      },
      // pocket儿童协议
      {
        path: '/kid_deal_pocket',
        name: 'kid_deal_pocket',
        component: () => import('../views/kid_deal_pocket/index.vue'),
      },
      // nivi儿童协议
      {
        path: '/kid_deal_nivi',
        name: 'kid_deal_nivi',
        component: () => import('../views/kid_deal_nivi/index.vue'),
      },
      // 游戏钻说明
      {
        path: '/game_coin_des',
        name: 'game_coin_des',
        component: () => import('../views/game_coin_des/index.vue'),
      },
      // 图鉴礼物说明
      {
        path: '/image_guide_1',
        name: 'image_guide_1',
        component: () => import('../views/image_guide/image_guide_1.vue'),
      },
      {
        path: '/image_guide_2',
        name: 'image_guide_2',
        component: () => import('../views/image_guide/image_guide_2.vue'),
      },
      {
        path: '/image_guide_3',
        name: 'image_guide_3',
        component: () => import('../views/image_guide/image_guide_3.vue'),
      },
      {
        path: '/image_guide_4',
        name: 'image_guide_4',
        component: () => import('../views/image_guide/image_guide_4.vue'),
      },
];
const router = new VueRouter({
  // mode: 'history',//调试模式
  // base: '/history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
